import script from "./RoundResults.vue?vue&type=script&setup=true&lang=js"
export * from "./RoundResults.vue?vue&type=script&setup=true&lang=js"

import "./RoundResults.vue?vue&type=style&index=0&id=08c72c1f&lang=css"

const __exports__ = script;

export default __exports__